import { metricConfig } from "./metricConfigBuilder";

export const getXDEFlavouredMetrics = (selectedMetrics) => {
    const xdeFormattedMetrics = [];
    const groupedMap = new Map();
    if(metricConfig) {
        Object.keys(metricConfig)
            .forEach(key => { 
                            if(!groupedMap.has(metricConfig[key].code)){
                                const exists = selectedMetrics.some(({metric}) => metric === metricConfig[key].code ) 
                                xdeFormattedMetrics.push({
                                    colHelp : metricConfig[key].displayName,
                                    colId : metricConfig[key].code,
                                    colText : metricConfig[key].displayName,
                                    dropDowns : getXDEFlavouredTimeperiods(metricConfig[key],selectedMetrics),
                                    expand : false,
                                    fieldType : null,
                                    groupId : 'Optional',
                                    mandatoryYN : null,
                                    selected : exists
                                })
                                groupedMap.set(metricConfig[key].code);
                            }
                            
                            });
    }else{
        console.log("Metrics config is not ready");
    }

    const getTimePeriods = (tp) => {
        return tp != null ? tp :"";
    }


    const xdeMetricsOrder = selectedMetrics.map(metric => {
        // Might need to loop thru applicableTps and get the displayname for Tps, possibly a map is good.TODO
        const tp = getTimePeriods(metric.timeperiod);
        return {
            colHelp: metric.metric,
            colId: metric.metric + (tp ? '|' + tp : ''),
            colText: metricConfig[metric.metric]?.displayName + ' ' + tp,
            mandatoryYN: "N",
            fieldType: null,
            groupId: "Optional",
            selected: true,
            expand: false,
            dropDowns: []
        }
    })


    return {xdeFormattedMetrics, xdeMetricsOrder};

}

const getXDEFlavouredTimeperiods = (metricObj, selectedMetrics) => {
    const xdeFormattedTimeperiods = [];
    if (!metricObj.isTimePeriodMetric) {
        return [];
    }
    const timeperiods = metricObj?.applicableTimeperiods;
    const metricCode = metricObj?.code;
    timeperiods.map(tp => {
        const exists = selectedMetrics.some(({metric, timeperiod}) => `${metric}|${timeperiod}` === `${metricCode}|${tp.name}` ) 
        xdeFormattedTimeperiods.push({
            colText : tp.displayName,
            colId : metricCode + "|" +tp.name,
            dropDowns : [],
            expand : false,
            selected : exists
        })
    })

    return xdeFormattedTimeperiods;
}


